/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const HealthResponseOutput = zod.object({
  status: zod.literal('ok'),
});

export type HealthResponseOutput = zod.input<typeof HealthResponseOutput>;
export type HealthResponseOutputOutput = zod.output<typeof HealthResponseOutput>;
